import { render, staticRenderFns } from "./wrappMarketVaule.vue?vue&type=template&id=6ef3d538&scoped=true&"
import script from "./wrappMarketVaule.vue?vue&type=script&lang=js&"
export * from "./wrappMarketVaule.vue?vue&type=script&lang=js&"
import style0 from "./wrappMarketVaule.vue?vue&type=style&index=0&id=6ef3d538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef3d538",
  null
  
)

export default component.exports